import React from "react";
import Blank from "../../../DefaultStyles/Blank";
import OldChatReport from "./Old/OldChatReport";
import OldReportComplete from "./Old/OldReportComplete";
import ChatReport from "./ChatReportComplete/ChatReport";
import ReportComplete from "./ChatReportComplete/ReportComplete";
import { isNewChat } from "../../../../pages/Party/ChatInfo";

export default function ChatReportComplete() {
  return (
    <>
      {isNewChat ? <ChatReport /> : <OldChatReport />}
      <Blank blankHeight={16} />
      {isNewChat ? <ReportComplete /> : <OldReportComplete />}
    </>
  );
}
